window.rfqModal = {
  image: '',

  showLoader() {
    showModal();
  },

  show(rfqPopupUrl) {
    getModalContent(rfqPopupUrl);
  },

  bind(image, selector = '[data-type="wc-cta-modal"]:not(.disabled)') {
    this.image = image;
    $(selector).off('click', handlerClick);
    $(selector).on('click', handlerClick);
  },

  close() {
    $('.modal.in').modal('hide');
  },
};

function handlerClick(event) {
  event.preventDefault();
  if (!isAnyModalOpen()) {
    if (isModalNeed(this)) {
      showModal();
      getModalContent(getUrlFromButton(this));
    } else {
      window.location.href = this.getAttribute('data-dx-href');
    }
  }
}
function getCookie(name) {

  const cookies = document.cookie.split('; ');

  for (let cookie of cookies) {
    if (cookie.includes(name)) {
      const [name, value] = cookie.split('=');
      return decodeURIComponent(value);
    }
  }

  return null;
}
function getUrlFromButton(button) {
  var url = new URL(button.getAttribute('data-href'));
  return url.href;
}

function getModalContent(rfqPopupUrl) {
  $.get({
    url: rfqPopupUrl,
    xhrFields: {
      withCredentials: true,
    },
    success: refreshModalData,
  });
}

function isAnyModalOpen() {
  return typeof bootbox === 'undefined' && $('.modal.in').length > 0;
}

function showModal() {
  var modalClassName = 'rfq-seo-popup';
  var $dialog = bootbox.dialog({
    message: createLoader(),
    className: modalClassName,
    size: 'large',
    onEscape: function () {
      const valuesAbandonedCart = getCookie('serviceRequestForm-development');
      if($('.rfq-seo-popup-stopper').length > 0) {
        return false;
      }
      var $stopperDialog = bootbox.dialog({
        message: createStopper(),
        className: modalClassName + '-stopper',
        size: 'large',
        closeButton: false,
        buttons: [
          {
            label: __("Salir"),
            className: "btn btn-default exit",
            callback: function () {
              const data =  JSON.parse(valuesAbandonedCart);

              if (data?.postalCode && data?.customerEmail) {
                sendIfCloseModalAfterPostalCode({
                  event: 'abandoned_cart',
                  message: 'User closed the service request modal',
                  data: valuesAbandonedCart,
                });
              }

              $('.' + modalClassName).find('.bootbox-close-button').attr('data-dismiss', 'modal');
              $('.' + modalClassName).modal('hide');
            }
          },
          {
            label: __("Continuar Solicitud"),
            className: "btn btn-primary continue",
            callback: function () {
              $stopperDialog.modal('hide');
            }
          }
        ],
        onEscape: function () {
          $stopperDialog.modal('hide');
        },
      });
      $stopperDialog.bind('shown.bs.modal', function () {
        $('.btn-primary.continue').blur();
        var progress_value = parseInt($('#rfq-seo-popup-content').find('.progress-bar').attr('data-progress'));
        var first_line = '';

        if (progress_value >= 50) {
          first_line = __('Tienes el <strong>{progress_value}% de las preguntas completadas</strong> <br/>', {
            progress_value: progress_value,
          });
        }
        $('#first-line-caption').html(first_line);
      });
      return false;
    },
  }).init(function () {
    $('.' + modalClassName).find('.bootbox-close-button').attr('data-dismiss', null);
  });
}

function sendIfCloseModalAfterPostalCode(data) {
  $.ajax({
    url: window.base_2030_api + '/v1/customer_abandoned_cart',
    contentType: 'application/json',
    data: JSON.stringify(data),
    type: 'POST'
  });
}

function IsJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

function refreshModalData(data) {
  $('.bootbox-body').html(
    '<div id="rfq-seo-popup-content" class="hidden">' + data + '</div>'
  );
}

function createLoader() {
  return ' \
    <div id="loading-placeholder" style="min-height: 400px;"> \
      <div class="content-placeholder-geometric"> \
        <div class="blocks"> \
          <span class="element first-element"></span> \
          <span class="element second-element"></span> \
          <span class="element third-element"></span> \
        </div> \
      </div> \
    </div>';
}

function createStopper() {
  return ' \
    <div id="rfq-seo-popup-stopper-content"> \
      <p class="stopper-title">' + __("¿Seguro que quieres salir?") + ' </p> \
      <div class="stopeer-caption"> \
        <p id="first-line-caption"></p> \
        <p id="second-line-caption">' + __("Estás a un paso de conseguir tus presupuestos") + '</p> \
      </div> \
      <img src="' + this.rfqModal.image + '" alt=""/> \
    </div>';
}

function isModalNeed(button) {
  return button.getAttribute('data-dx-href') == null || button.getAttribute('data-business-id') != null;
}
